// Existing sessions store a JSON string. Older clients may store a raw JWT.
export default function getAuthToken() {
  const stored = localStorage.getItem('token')
  if (!stored) return ''

  try {
    const token = JSON.parse(stored)
    if (typeof token === 'string' && token.trim() && token !== 'undefined' && token !== 'null') {
      return token
    }
  } catch (error) {
    if (/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(stored)) {
      return stored
    }
  }

  localStorage.removeItem('token')
  return ''
}
